import moji from 'moji'
import * as wanakana from 'wanakana'

export const formatPhoneNumber = (inputPhone: any) => {
  let phoneNumber = ''
  if (inputPhone) {
    // Free dials
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    inputPhone.match(regExpAreaCode.free) // 0120
      ? (phoneNumber = preFormatNumber(inputPhone, 4, 3))
      : inputPhone.match(regExpAreaCode.incomingBilling) // 0800
      ? (phoneNumber = preFormatNumber(inputPhone, 4, 3))
      : inputPhone.match(regExpAreaCode.mobile) // 020,050,070,080,090
      ? (phoneNumber = preFormatNumber(inputPhone, 3, 4))
      : inputPhone.match(regExpAreaCode.four)
      ? (phoneNumber = preFormatNumber(inputPhone, 5, 1))
      : inputPhone.match(regExpAreaCode.three)
      ? (phoneNumber = preFormatNumber(inputPhone, 4, 2))
      : inputPhone.match(regExpAreaCode.two)
      ? (phoneNumber = preFormatNumber(inputPhone, 3, 3))
      : inputPhone.match(regExpAreaCode.one)
      ? (phoneNumber = preFormatNumber(inputPhone, 2, 4))
      : (phoneNumber = inputPhone)
  }
  return phoneNumber
}
export function formatPolicyAndBranchNo (inputValue: string): any {
  const digitsOnly = inputValue.replace(/[^\d]/g, '').slice(0, 15)
  if (digitsOnly.length > 10) {
    const formattedValue = digitsOnly.replace(/^(\d{10})(\d{1,5})/, '$1 $2')
    return formattedValue
  } else {
    return digitsOnly
  }
}

export function formatPhNo (inputValue: string): any {
  const digitsOnly = inputValue.replace(/[^\d]/g, '').slice(0, 14)
  return digitsOnly
}

export const convertToHalfWidth = (value: string): string => {
  value = value.replaceAll('・', '.').replaceAll('･', '.')
  const halfWidth = moji(value)
    .convert('ZK', 'HK')
    .convert('ZE', 'HE')
    .convert('ZS', 'HS')
    .toString()
    .replaceAll('ｰ', '-')
    .replaceAll('ー', '-')
    // eslint-disable-next-line no-irregular-whitespace
    .replaceAll(/　/g, ' ')
  return halfWidth
}
export const convertToKatakana = (value: any) => {
  let formattedValue = ''
  Array.from(value).forEach((char: any) => {
    formattedValue += wanakana.isHiragana(char) ? wanakana.toKatakana(char) : char
  })
  return formattedValue
}
export function formatDigitOnly (inputValue: any): any {
  return convertToHalfWidth(inputValue).replaceAll('-', '').replace(/\D/g, '')
}
export const formatZipCode = (zipCodeInput: string): string => {
  const digitOnly = convertToHalfWidth(zipCodeInput).replace(/\D/g, '')
  const zipCode = digitOnly.slice(0, 7)

  if (zipCode.length <= 3) return zipCode
  return `${zipCode.slice(0, 3)}-${zipCode.slice(3)}`
}
const preFormatNumber = (str: any, area1: any, area2: any) => {
  if (str) {
    let num1 = ''
    let num2 = ''
    let num3 = ''
    let preNumber = ''
    const match = str.match(/-/g) ? str.match(/-/g) : 'null'
    const hyphen = match !== 'null' ? match.length : 0
    switch (true) {
      case str.length === area1 + 1:
        preNumber = str
        break
      case str.length > area1 + 1 && str.length <= area1 + area2 + 1 + hyphen:
        if (hyphen === 0) {
          num1 = str.substring(0, area1)
          num2 = str.substring(area1)
          preNumber = num1 + '-' + num2
        } else {
          preNumber = str
        }
        break
      case str.length > area1 + area2 + 1 + hyphen:
        if (hyphen !== 2) {
          num1 = str.substring(0, area1)
          num2 = str.substring(area1 + hyphen, area1 + area2 + hyphen)
          num3 = str.substring(area1 + area2 + hyphen)
          preNumber = num1 + '-' + num2 + '-' + num3
        } else {
          preNumber = str
        }
        break
    }
    return preNumber
  }
  return ''
}
class RegExpAreaCode {
  reg: RegExp
  constructor (replaceCode: any) {
    this.reg = new RegExp('^0' + '(' + replaceCode + ')' + '[0-9-]+$')
  }
}

const numberOne = '3_4_6'
const numberTwo =
  '11_15_17_18_19_22_23_24_25_26_27_28_29_42_43_44_45_46_47_48_49_52_53_54_55_58_59_' +
  '72_73_75_76_77_78_79_82_83_84_86_87_88_89_92_93_95_96_97_98_99'
const numberThree =
  '123_124_125_126_133_134_135_136_137_138_139_142_143_144_145_146_152_153_154_155_' +
  '156_157_158_162_163_164_165_166_167_172_173_174_175_176_178_179_182_183_184_185_' +
  '186_187_191_192_193_194_195_197_198_220_223_224_225_226_228_229_233_234_235_237_' +
  '238_240_241_242_243_244_246_247_248_250_254_255_256_257_258_259_260_261_263_264_' +
  '265_266_267_268_269_270_274_276_277_278_279_280_282_283_284_285_287_288_289_291_' +
  '293_294_295_296_297_299_422_428_436_438_439_460_463_465_466_467_470_475_476_478_' +
  '479_480_493_494_495_531_532_533_536_537_538_539_544_545_547_548_550_551_553_554_' +
  '555_556_557_558_561_562_563_564_565_566_567_568_569_572_573_574_575_576_577_578_' +
  '581_584_585_586_587_594_595_596_597_598_599_721_725_735_736_737_738_739_740_742_' +
  '743_744_745_746_747_748_749_761_763_765_766_767_768_770_771_772_773_774_776_778_' +
  '779_790_791_794_795_796_797_798_799_820_823_824_826_827_829_833_834_835_836_837_' +
  '838_845_846_847_848_852_853_854_855_856_857_858_859_863_865_866_867_868_869_875_' +
  '877_879_880_883_884_885_887_889_892_893_894_895_896_897_898_920_930_940_942_943_' +
  '944_946_947_948_949_950_952_954_955_956_957_959_964_965_966_967_968_969_972_973_' +
  '974_977_978_979_980_982_983_984_985_986_987_993_994_995_996_997'
const numberFour =
  '1267_1372_1374_1377_1392_1397_1398_1456_1457_1466_1547_1558_1564_1586_1587_1632_' +
  '1634_1635_1648_1654_1655_1656_1658_4992_4994_4996_4998_5769_5979_7468_8387_8388_' +
  '8396_8477_8512_8514_9496_9802_9912_9913_9969'
const freeNumber = '120_990_570'
const ibNumber = '800'
const mobileNumber = '20_50_70_80_90'

export const areaCodeList = [
  { id: 'one', number: numberOne },
  { id: 'two', number: numberTwo },
  { id: 'three', number: numberThree },
  { id: 'four', number: numberFour },
  { id: 'free', number: freeNumber },
  { id: 'ib', number: ibNumber },
  { id: 'mobile', number: mobileNumber }
]
const digitsReplace = areaCodeList.map((digits) => {
  return digits.number.replace(/_/g, '|')
})

export const regExpAreaCode = {
  one: new RegExpAreaCode(digitsReplace[0]).reg,
  two: new RegExpAreaCode(digitsReplace[1]).reg,
  three: new RegExpAreaCode(digitsReplace[2]).reg,
  four: new RegExpAreaCode(digitsReplace[3]).reg,
  free: new RegExpAreaCode(digitsReplace[4]).reg,
  incomingBilling: new RegExpAreaCode(digitsReplace[5]).reg,
  mobile: new RegExpAreaCode(digitsReplace[6]).reg
}
